// components/ServicesSection/ServicesSection.jsx
import React from "react";
import {
  Code,
  TrendingUp,
  Lightbulb,
  Cloud,
  Settings,
  Users,
  Package,
  Database,
  Cpu,
} from "lucide-react";
import ServiceCard from "./ServiceCard";
import "./ServicesSection.css";
import navision from "../../assets/images/navision.png";

const ServicesSection = () => {
  const services = [
    {
      icon: null,
      title: "Microsoft Dynamics Business Central",
      description:
        "Our flagship ERP solution for complete business management, financials, and operations automation.",
      featured: true,
      logo: navision,
    },
    {
      icon: Cpu,
      title: "AI Integration",
      description:
        "Implement cutting-edge AI solutions to automate processes and gain competitive advantage.",
    },
    {
      icon: Database,
      title: "Data Analytics",
      description:
        "Transform raw data into actionable insights with powerful BI tools and dashboards.",
    },
    {
      icon: Code,
      title: "Web Development",
      description:
        "Building stunning, responsive, and high-performance websites tailored to your business needs.",
    },
    {
      icon: TrendingUp,
      title: "Mobile App Development",
      description:
        "Crafting intuitive and powerful mobile applications for iOS and Android platforms.",
    },
    {
      icon: Lightbulb,
      title: "IT Consulting",
      description:
        "Providing expert guidance and strategic solutions to optimize your IT infrastructure.",
    },
    {
      icon: Cloud,
      title: "Cloud Solutions",
      description:
        "Implementing scalable and secure cloud-based solutions for enhanced flexibility and efficiency.",
    },
    {
      icon: Users,
      title: "Cyber Security",
      description:
        "Protecting your digital assets with robust security measures and proactive threat detection.",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <h2 className="services-title font-heading">
          Our <span className="services-title-highlight">Solutions</span>
        </h2>
        <p className="services-subtitle font-body">
          Specializing in Microsoft Dynamics NAV with comprehensive IT services
          to drive your digital transformation.
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              featured={service.featured}
              logo={service.logo}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
